import { FormHelper } from '@presentation/components/FormHelper';
import type { Salarie } from '@shared/types/Salarie';
import type { StatutConge, TypeConge } from '@shared/types/Conge';

const TYPES: { value: TypeConge; label: string }[] = [
  { value: 'annuel', label: 'Congé annuel' },
  { value: 'maternite', label: 'Maternité' },
  { value: 'paternite', label: 'Paternité' },
  { value: 'maladie', label: 'Maladie' },
  { value: 'evenement_familial', label: 'Événement familial' },
  { value: 'sans_solde', label: 'Sans solde' },
  { value: 'autre', label: 'Autre' },
];

const STATUTS_INITIAUX: { value: StatutConge; label: string }[] = [
  { value: 'demande', label: 'En attente' },
  { value: 'valide', label: 'Approuvé' },
  { value: 'refuse', label: 'Refusé' },
];

function attrEscape(value: string): string {
  return value.replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;');
}

export function renderCongeForm(opts: {
  salaries?: readonly Salarie[];
  salarieId?: string;
}): string {
  const salarieField = opts.salaries
    ? FormHelper.select(
        'salarie_id',
        'Salarié',
        opts.salaries.map((s) => ({
          value: s.id,
          label: `${s.prenom} ${s.nom}${s.poste ? ` — ${s.poste}` : ''}`,
        })),
        { required: true, value: opts.salarieId, placeholder: 'Rechercher un salarié…' },
      )
    : `<input type="hidden" name="salarie_id" value="${attrEscape(opts.salarieId ?? '')}" />`;

  return `
    <form id="conge-form">
      ${salarieField}
      ${FormHelper.select('type', 'Type', TYPES, { required: true, value: 'annuel' })}
      ${FormHelper.select('statut', 'Statut initial', STATUTS_INITIAUX, { required: true, value: 'demande' })}
      ${FormHelper.field('date_debut', 'Du', 'date', { required: true })}
      ${FormHelper.field('date_fin', 'Au', 'date', { required: true })}
      ${FormHelper.textarea('motif', 'Motif', { placeholder: 'Facultatif', rows: 3 })}
      <div style="display:flex;justify-content:flex-end;gap:8px;margin-top:16px;">
        <button type="button" class="btn btn-ghost" data-cancel>Annuler</button>
        <button type="submit" class="btn btn-primary">Enregistrer</button>
      </div>
    </form>`;
}
